module.exports = __webpack_public_path__ + "img/coinbase-wallet.4ab86c39.webp";